<template>
</template>
<script>
    import { mapState,mapActions } from 'vuex';

    export default {
        name: "ThankYouSection",
        data () {
            return {
                sectionType: "thank-you-section",
                givesContextToChildren: true,
            }
        },
    }
</script>
